// extracted by mini-css-extract-plugin
export default {"card":"Card_card__PD-TY","cardTitle":"Card_cardTitle__dqyCC","success":"Card_success__C39fx","failure":"Card_failure__FRc8b"};